import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  getAllMatchesOddsSoccerAPI,
  getAllMatchesOddsTennisAPI,
} from "../service/soccer&tennis";
import { getAllMatchesOddsCricketAPI } from "../service/cricket";
import moment from "moment";
import Loader from "../components/Loader";
import CasinoLoader from "./universalCasino/CasinoLoader";

export default function InPlay() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [loading, setLoading] = React.useState(false);
  const [showCasinoLoader, setShowCasinoLoader] = React.useState(false);
  const [selectedGame, setSelectedGame] = React.useState(null);
  const [selectedFilter, setSelectedFilter] = React.useState("inPlay");
  const [casinoListMap, setCasinoListMap] = React.useState({
    ALL: [
      {
        name: "POINT TEEN PATTI",
        link: "/casino/generic/UNI_POINT_TEEN_PATTI",
        image:
          "/assets/casino/20-20 teenpatti.jpeg",
      },
      {
        name: "JOKER TEEN PATTI",
        link: "/casino/generic/UNI_JOKER_TEEN_PATTI",
        image:
          "/assets/casino/Joker teenpatti.jpeg",
      },
      {
        name: "MUFLIS TEEN PATTI",
        link: "/casino/UNI_MUFLIS_TEEN_PATTI",
        image: "/assets/casino/muflisteenpatti-01.jpeg",
      },
      {
        name: "1DAY TEEN PATTI",
        link: "/casino/UNI_1DAY_TEEN_PATTI",
        image: "/assets/casino/1 Day teenpatti.jpeg",
      },
      {
        name: "DTL TEENPATTI",
        link: "/casino/generic/UNI_DTL_TEENPATTI",
        image: "/assets/casino/DTL.jpeg",
      },
      {
        name: "20-20 TEENPATTI",
        link: "/casino/distributed/back/generic/UNI_20_20_TEENPATTI",
        image:
          "/assets/casino/20-20 teenpatti.jpeg",
      },
      {
        name: "20-20 POKER - A",
        link: "/casino/poker/generic/UNI_20_20_POKER_A",
        image: "/assets/casino/Poker.jpeg",
      },
      {
        name: "20-20 POKER - B",
        link: "",
        image: "/assets/casino/Poker.jpeg",
      },
      {
        name: "29 CARD BACCARAT",
        link: "/casino/poker/generic/UNI_29_CARD_BACCARAT",
        image: "/assets/casino/Baccarat.jpeg",
      },
      {
        name: "BACCARAT - A",
        link: "/casino/baccarat/generic/UNI_BACCARAT_A",
        image: "/assets/casino/Baccarat.jpeg",
      },
      {
        name: "BACCARAT",
        link: "/casino/baccarat/generic/UNI_BACCARAT",
        image: "/assets/casino/Baccarat.jpeg",
      },
      {
        name: "BACCARAT - C",
        link: "/casino/baccarat/generic/UNI_BACCARAT_C",
        image: "/assets/casino/Baccarat.jpeg",
      },
      {
        name: "DRAGON TIGER",
        link: "/casino/generic/UNI_DRAGON_TIGER",
        image: "/assets/casino/dragon tiger-01.jpeg",
      },
      {
        name: "20-20 DRAGON TIGER",
        link: "/casino/distributed/back/generic/UNI_20_20_DRAGON_TIGER",
        image:
          "/assets/casino/Dragontiger.jpeg",
      },
      {
        name: "FAST DRAGON TIGER",
        link: "/casino/fas/UNI_FAST_DRAGON_TIGER",
        image:
          "/assets/casino/Dragontiger.jpeg",
      },
      {
        name: "1 DAY DRAGON TIGER",
        link: "/casino/UNI_1_DAY_DRAGON_TIGER",
        image:
          "/assets/casino/1 Day Dragon tiger.jpeg",
      },
      {
        name: "DTL - A",
        link: "/casino/dtl/UNI_DTL_TEENPATTI",
        image: "/assets/casino/DTL.jpeg",
      },
      {
        name: "32 CARDS - B",
        link: "/casino/generic/UNI_32_CARDS_B",
        image: "/assets/casino/32 cards.jpeg",
      },
      {
        name: "32 CARDS - A",
        link: "/casino/generic/UNI_32_CARDS_A",
        image: "/assets/casino/32 cards.jpeg",
      },
      {
        name: "ANDAR BAHAR - A",
        link: "/casino/ab/UNI_ANDAR_BAHAR_A",
        image: "/assets/casino/Andar Bahar.jpeg",
      },
      {
        name: "ANDAR BAHAR - C",
        link: "/casino/ab/UNI_ANDAR_BAHAR_C",
        image: "/assets/casino/Andar Bahar.jpeg",
      },
      {
        name: "LUCKY 7 - A",
        link: "/casino/distributed/back/generic/UNI_LUCKY_7_A",
        image: "/assets/casino/Lucky-7.jpeg",
      },
      {
        name: "FAST LUCKY - 7",
        link: "/casino/fas/UNI_FAST_LUCKY_7",
        image: "/assets/casino/Lucky-7.jpeg",
      },
      {
        name: "LUCKY 7 - B",
        link: "/casino/generic/UNI_LUCKY_7_B",
        image: "/assets/casino/Lucky-7.jpeg",
      },
      {
        name: "3 CARD JUDGEMENT - A",
        link: "/casino/UNI_3_CARD_JUDGMENT_A",
        image:
          "https://queenexch.com/api/users/images/3Card Judgement-min-min.png",
      },
      {
        name: "CASINO WAR",
        link: "/casino/UNI_CASINO_WAR",
        image: "https://queenexch.com/api/users/images/CasinoWar-min.png",
      },
      {
        name: "INSTANT WORLI",
        link: "",
        image: "https://queenexch.com/api/users/images/Instant Worli-min.png",
      },
      {
        name: "BOLLYWOOD CASINO",
        link: "",
        image:
          "https://queenexch.com/api/users/images/Bollywood Casino 2-min.png",
      },
      {
        name: "INA MINA DIKA",
        link: "/casino/aaa/UNI_INA_MINA_DIKA",
        image:
          "https://queenexch.com/api/users/images/InaMinaDika-01-min-min.png",
      },
      {
        name: "AMAR AKBAR ANTHONY",
        link: "/casino/aaa/UNI_AMAR_AKBAR_ANTHONY",
        image:
          "/assets/casino/AmarAkbarAnthony-01.jpeg",
      },
      {
        name: "LOTTERY",
        link: "",
        image: "https://queenexch.com/api/users/images/Lottery 1-min.png",
      },
      {
        name: "20-20 CARD RACE",
        link: "/casino/generic/UNI_20_20_CARD_RACE",
        image: "/assets/casino/CardRace.jpeg",
      },
      {
        name: "1 CARD METER",
        link: "/casino/distributed/back/generic/UNI_1_CARD_METER",
        image: "https://queenexch.com/api/users/images/1 Card Meter-min.png",
      },
      {
        name: "1 CARD 20-20",
        link: "/casino/baccarat/generic/UNI_1_CARD_20_20",
        image: "https://queenexch.com/api/users/images/1 Card-min.png",
      },
      {
        name: "TRIO",
        link: "",
        image: "https://queenexch.com/api/users/images/Trio-min.png",
      },
      {
        name: "KBC",
        link: "",
        image: "https://queenexch.com/api/users/images/KBC-min.png",
      },
      {
        name: "CASINO METER",
        link: "",
        image: "https://queenexch.com/api/users/images/CasinoMeter-min.png",
      },
      {
        name: "EVOLUTION",
        link: "",
        image:
          "https://universe-studio.s3.ap-south-1.amazonaws.com/abevolution+gaming-min.png",
      },
      {
        name: "EZUGI",
        link: "",
        image:
          "https://universe-studio.s3.ap-south-1.amazonaws.com/Ezugi+(4)-min.png",
      },
      // {
      //   name: "BALLOON",
      //   link: "",
      //   image: "/assets/casino/Balloon.jpeg",
      // },
      {
        name: "HEADS & TAILS",
        link: "/casino/UNI_HEADS_AND_TAILS",
        image: "/assets/casino/Head n Tails.jpeg",
      },
      {
        name: "LUCKY 0 TO 9",
        link: "/casino/UNI_LUCKY_0_TO_9",
        image: "/assets/casino/Lucky 0 to 9.jpeg",
      },
    ],
    "ANDAR BAHAR": [
      {
        name: "ANDAR BAHAR - A",
        link: "/casino/ab/UNI_ANDAR_BAHAR_A",
        image: "/assets/casino/Andar Bahar.jpeg",
      },
      {
        name: "ANDAR BAHAR - C",
        link: "/casino/ab/UNI_ANDAR_BAHAR_C",
        image: "/assets/casino/Andar Bahar.jpeg",
      },
    ],
    "LUCKY 7": [
      {
        name: "LUCKY 7 - A",
        link: "/casino/distributed/back/generic/UNI_LUCKY_7_A",
        image: "/assets/casino/Lucky-7.jpeg",
      },
      {
        name: "FAST LUCKY - 7",
        link: "/casino/fas/UNI_FAST_LUCKY_7",
        image: "/assets/casino/Lucky-7.jpeg",
      },
      {
        name: "LUCKY 7 - B",
        link: "/casino/generic/UNI_LUCKY_7_B",
        image: "/assets/casino/Lucky-7.jpeg",
      },
    ],
    "TEEN PATTI": [
      {
        name: "POINT TEEN PATTI",
        link: "/casino/generic/UNI_POINT_TEEN_PATTI",
        image:
          "/assets/casino/20-20 teenpatti.jpeg",
      },
      {
        name: "JOKER TEEN PATTI",
        link: "/casino/generic/UNI_JOKER_TEEN_PATTI",
        image:
          "/assets/casino/Joker teenpatti.jpeg",
      },
      {
        name: "MUFLIS TEEN PATTI",
        link: "/casino/UNI_MUFLIS_TEEN_PATTI",
        image: "/assets/casino/muflisteenpatti-01.jpeg",
      },
      {
        name: "1DAY TEEN PATTI",
        link: "/casino/UNI_1DAY_TEEN_PATTI",
        image: "/assets/casino/1 Day teenpatti.jpeg",
      },
      {
        name: "DTL TEENPATTI",
        link: "/casino/generic/UNI_DTL_TEENPATTI",
        image: "/assets/casino/DTL.jpeg",
      },
      {
        name: "20-20 TEENPATTI",
        link: "/casino/distributed/back/generic/UNI_20_20_TEENPATTI",
        image:
          "/assets/casino/20-20 teenpatti.jpeg",
      },
    ],
    POKER: [
      {
        name: "20-20 POKER - A",
        link: "/casino/poker/generic/UNI_20_20_POKER_A",
        image: "/assets/casino/Poker.jpeg",
      },
      {
        name: "20-20 POKER - B",
        link: "",
        image: "/assets/casino/Poker.jpeg",
      },
    ],
    "3 CARD JUDGEMENT": [
      {
        name: "3 CARD JUDGEMENT - A",
        link: "/casino/UNI_3_CARD_JUDGMENT_A",
        image:
          "https://queenexch.com/api/users/images/3Card Judgement-min-min.png",
      },
    ],
    "CASINO WAR": [
      {
        name: "CASINO WAR",
        link: "/casino/UNI_CASINO_WAR",
        image: "https://queenexch.com/api/users/images/CasinoWar-min.png",
      },
    ],
    WARLI: [
      {
        name: "INSTANT WORLI",
        link: "",
        image: "https://queenexch.com/api/users/images/Instant Worli-min.png",
      },
    ],
    LOTTERY: [
      {
        name: "LOTTERY",
        link: "",
        image: "https://queenexch.com/api/users/images/Lottery 1-min.png",
      },
    ],
    RACE: [
      {
        name: "20-20 CARD RACE",
        link: "/casino/generic/UNI_20_20_CARD_RACE",
        image: "/assets/casino/CardRace.jpeg",
      },
    ],
    OTHER: [
      {
        name: "1 CARD METER",
        link: "/casino/distributed/back/generic/UNI_1_CARD_METER",
        image: "https://queenexch.com/api/users/images/1 Card Meter-min.png",
      },
      {
        name: "1 CARD 20-20",
        link: "/casino/baccarat/generic/UNI_1_CARD_20_20",
        image: "https://queenexch.com/api/users/images/1 Card-min.png",
      },
      {
        name: "TRIO",
        link: "",
        image: "https://queenexch.com/api/users/images/Trio-min.png",
      },
      {
        name: "KBC",
        link: "",
        image: "https://queenexch.com/api/users/images/KBC-min.png",
      },
      {
        name: "CASINO METER",
        link: "",
        image: "https://queenexch.com/api/users/images/CasinoMeter-min.png",
      },
    ],
    BOLLYWOOD: [
      {
        name: "BOLLYWOOD CASINO",
        link: "",
        image:
          "https://queenexch.com/api/users/images/Bollywood Casino 2-min.png",
      },
      {
        name: "INA MINA DIKA",
        link: "/casino/aaa/UNI_INA_MINA_DIKA",
        image:
          "https://queenexch.com/api/users/images/InaMinaDika-01-min-min.png",
      },
      {
        name: "AMAR AKBAR ANTHONY",
        link: "/casino/aaa/UNI_AMAR_AKBAR_ANTHONY",
        image:
          "/assets/casino/AmarAkbarAnthony-01.jpeg",
      },
    ],
    BACCARAT: [
      {
        name: "29 CARD BACCARAT",
        link: "/casino/poker/generic/UNI_29_CARD_BACCARAT",
        image: "/assets/casino/Baccarat.jpeg",
      },
      {
        name: "BACCARAT - A",
        link: "/casino/baccarat/generic/UNI_BACCARAT_A",
        image: "/assets/casino/Baccarat.jpeg",
      },
      {
        name: "BACCARAT",
        link: "/casino/baccarat/generic/UNI_BACCARAT",
        image: "/assets/casino/Baccarat.jpeg",
      },
      {
        name: "BACCARAT - C",
        link: "/casino/baccarat/generic/UNI_BACCARAT_C",
        image: "/assets/casino/Baccarat.jpeg",
      },
    ],
    "32CARDS": [
      {
        name: "32 CARDS - A",
        link: "/casino/generic/UNI_32_CARDS_A",
        image: "/assets/casino/32 cards.jpeg",
      },
      {
        name: "32 CARDS - B",
        link: "/casino/generic/UNI_32_CARDS_B",
        image: "/assets/casino/32 cards.jpeg",
      },
    ],
    "DRAGON TIGER": [
      {
        name: "DRAGON TIGER",
        link: "/casino/generic/UNI_DRAGON_TIGER",
        image: "/assets/casino/dragon tiger-01.jpeg",
      },
      {
        name: "20-20 DRAGON TIGER",
        link: "/casino/distributed/back/generic/UNI_20_20_DRAGON_TIGER",
        image:
          "/assets/casino/Dragontiger.jpeg",
      },
      {
        name: "FAST DRAGON TIGER",
        link: "/casino/fas/UNI_FAST_DRAGON_TIGER",
        image:
          "/assets/casino/Dragontiger.jpeg",
      },
      {
        name: "1 DAY DRAGON TIGER",
        link: "/casino/UNI_1_DAY_DRAGON_TIGER",
        image:
          "/assets/casino/1 Day Dragon tiger.jpeg",
      },
      {
        name: "DTL - A",
        link: "/casino/dtl/UNI_DTL_TEENPATTI",
        image: "/assets/casino/DTL.jpeg",
      },
    ],
  });
  const casinoScreenshotOrder = [
    "BALLOON", "20-20 TEENPATTI", "LUCKY 7 - A", "1DAY TEEN PATTI",
    "JOKER TEEN PATTI", "DRAGON TIGER", "BACCARAT", "ANDAR BAHAR - A",
    "32 CARDS - A", "20-20 POKER - A", "DTL - A", "1 DAY DRAGON TIGER",
    "MUFLIS TEEN PATTI", "20-20 CARD RACE", "AMAR AKBAR ANTHONY",
    "20-20 DRAGON TIGER", "HEADS & TAILS", "LUCKY 0 TO 9",
  ];
  const getCasinoGames = (games) => {
    if (games !== casinoListMap.ALL) return games;
    return casinoScreenshotOrder
      .map((name) => games.find((game) => game.name === name))
      .filter(Boolean);
  };
  const [casinoList, setCasinoList] = React.useState([
    { name: "ALL", value: "ALL", active: true },
    {
      name: "OUR CASINO",
      value: "OUR CASINO",
      enum: [
        { name: "ALL CASINO", value: "ALL", active: true },
        { name: "TEEN PATTI", value: "TEEN PATTI" },
        { name: "POKER", value: "POKER" },
        { name: "BACCARAT", value: "BACCARAT" },
        { name: "DRAGON TIGER", value: "DRAGON TIGER" },
        { name: "32CARDS", value: "32CARDS" },
        { name: "DRAGON TIGER", value: "DRAGON TIGER" },
        { name: "ANDAR BAHAR", value: "ANDAR BAHAR" },
        { name: "LUCKY 7", value: "LUCKY 7" },
        { name: "3 CARD JUDGEMENT", value: "3 CARD JUDGEMENT" },
        { name: "CASINO WAR", value: "CASINO WAR" },
        { name: "WARLI", value: "WARLI" },
        { name: "BOLLYWOOD", value: "BOLLYWOOD" },
        { name: "LOTTERY", value: "LOTTERY" },
        { name: "RACE", value: "RACE" },
        { name: "OTHER", value: "OTHER" },
      ],
    },
    {
      name: "OUR VIRTUAL",
      enum: [
        { name: "ALL", value: "ALL", active: true },
        { name: "V-TEENPATTI", value: "V-TEENPATTI" },
        { name: "V-LUCKY7", value: "V-LUCKY7" },
        { name: "V-OTHER", value: "V-OTHER" },
      ],
    },
  ]);
  const [filters, setFilters] = React.useState({
    inPlay: (item) => item.inPlay,
    today: (item) =>
      moment(item?.eventDate ? item?.eventDate : item?.eventTime).isSame(
        moment(),
        "day"
      ),
    tomorrow: (item) =>
      moment(item?.eventDate ? item?.eventDate : item?.eventTime).isSame(
        moment().add(1, "day"),
        "day"
      ),
  });
  const cricketData = useSelector((state) =>
    state?.gameData?.cricketGames.map((item) => {
      return {
        ...item,
        sport: "cricket",
      };
    })  
  );
  const tennisData = useSelector((state) =>
    state?.gameData?.tennisGames?.map((item) => {
      return {
        ...item,
        sport: "tennis",
      };
    })
  );
  const soccerData = useSelector((state) =>
    state?.gameData?.soccerGames?.map((item) => {
      return {
        ...item,
        sport: "soccer",
      };
    })
  );
  const gameMap = {
    cricket: cricketData,
    soccer: soccerData,
    tennis: tennisData,
  };

  const getSoccerMatches = async () => {
    const { response, code } = await getAllMatchesOddsSoccerAPI();
    if (code == 200) {
      dispatch({
        type: "gameData/setSoccerGames",
        payload: response,
      });
    }
  };
  const getTennisMatches = async () => {
    const { response, code } = await getAllMatchesOddsTennisAPI();
    if (code == 200) {
      dispatch({
        type: "gameData/setTennisGames",
        payload: response,
      });
    }
  };
  const getCricketMatches = async () => {
    const { response, code } = await getAllMatchesOddsCricketAPI();
    if (code == 200) {
      dispatch({
        type: "gameData/setCricketGames",
        payload: response,
      });
    }
  };
  useEffect(() => {
    setLoading(true);
    let interval;
    if (selectedGame == "cricket") {
      getCricketMatches();
      interval = setInterval(() => {
        getCricketMatches();
      }, 5000);
    } else if (selectedGame == "soccer") {
      getSoccerMatches();
      interval = setInterval(() => {
        getSoccerMatches();
      }, 5000);
    } else if (selectedGame == "tennis") {
      getTennisMatches();
      interval = setInterval(() => {
        getTennisMatches();
      }, 5000);
    } else {
      getSoccerMatches();
      getCricketMatches();
      getTennisMatches();
      interval = setInterval(() => {
        getSoccerMatches();
        getCricketMatches();
        getTennisMatches();
      }, 5000);
    }
    setLoading(false);
    return () => {
      clearInterval(interval);
      setLoading(false);
    };
  }, [selectedGame]);
  return (
    <app-inplay _nghost-ng-c111818244="" className="ng-star-inserted">
      {showCasinoLoader && <CasinoLoader />}
      {loading && <Loader />}
      <div _ngcontent-ng-c111818244="" className="row tabmenu">
        <ul _ngcontent-ng-c111818244="" id="inPlayTab" className="tab col3">
          <li _ngcontent-ng-c111818244="">
            <a
              onClick={() => setSelectedFilter("inPlay")}
              _ngcontent-ng-c111818244=""
              className={selectedFilter === "inPlay" ? "select" : ""}
            >
              In-Play
            </a>
          </li>
          <li _ngcontent-ng-c111818244="">
            <a
              onClick={() => setSelectedFilter("today")}
              className={selectedFilter === "today" ? "select" : ""}
              _ngcontent-ng-c111818244=""
            >
              Today
            </a>
          </li>
          <li _ngcontent-ng-c111818244="">
            <a
              onClick={() => setSelectedFilter("tomorrow")}
              className={selectedFilter === "tomorrow" ? "select" : ""}
              _ngcontent-ng-c111818244=""
            >
              Tomorrow
            </a>
          </li>
        </ul>
      </div>
      <div _ngcontent-ng-c111818244="" className="game-menu-tab inplay-match">
        {soccerData?.filter(filters[selectedFilter])?.length > 0 && (
          <div
            _ngcontent-ng-c111818244=""
            className="inplay-sportwise ng-star-inserted"
          >
            <div _ngcontent-ng-c111818244="" className="sporthead sporthead2">
              <h3 _ngcontent-ng-c111818244="">Soccer </h3>
            </div>
            <table
              _ngcontent-ng-c111818244=""
              className="table table-hover inplaytbl2"
            >
              <thead _ngcontent-ng-c111818244="" className="hideDesktop">
                <tr>
                  <th
                    _ngcontent-ng-c111818244=""
                    colSpan={2}
                    className="view-mobile"
                  />
                  <th _ngcontent-ng-c111818244="" className="text-center">
                    1
                  </th>
                  <th _ngcontent-ng-c111818244="" className="text-center">
                    X
                  </th>
                  <th _ngcontent-ng-c111818244="" className="text-center">
                    2
                  </th>
                </tr>
              </thead>
              <tbody _ngcontent-ng-c111818244="">
                {soccerData?.filter(filters[selectedFilter])?.map((item) => (
                  <tr _ngcontent-ng-c111818244="" className="ng-star-inserted">
                    <td
                      onClick={() => {
                        navigate(`/game/soccer/${item?.soccerId}`);
                      }}
                      _ngcontent-ng-c111818244=""
                      style={{ cursor: "pointer" }}
                    >
                      <a _ngcontent-ng-c111818244="" className="match-name">
                        <span _ngcontent-ng-c111818244="">
                          {item?.eventName}
                        </span>
                      </a>
                      {selectedFilter != "inPlay" && (
                        <p _ngcontent-ng-c111818244="" className="match-time">
                          {moment(
                            item?.eventDate
                              ? item?.eventDate + "Z"
                              : item?.eventTime + "Z"
                          ).format("DD-MM-yyyy HH:mm")}
                        </p>
                      )}
                      {selectedFilter == "inPlay" && (
                        <span
                          _ngcontent-ng-c111818244=""
                          className="in_play ng-star-inserted"
                        >
                          In-Play
                        </span>
                      )}
                      {/**/}
                      {/**/}
                      {/**/}
                      {/**/}
                    </td>
                    <td _ngcontent-ng-c111818244="" className="text-start"></td>
                    <td
                      _ngcontent-ng-c111818244=""
                      className="count hideDesktop"
                    >
                      <span _ngcontent-ng-c111818244="" className="back">
                        {item?.back1}
                      </span>
                      <span _ngcontent-ng-c111818244="" className="lay">
                        {" "}
                        {item?.lay1}
                      </span>
                    </td>
                    <td
                      _ngcontent-ng-c111818244=""
                      className="count hideDesktop"
                    >
                      <span _ngcontent-ng-c111818244="" className="back">
                        {" "}
                        {item?.back11}
                      </span>
                      <span _ngcontent-ng-c111818244="" className="lay">
                        {item?.lay11}{" "}
                      </span>
                    </td>
                    <td
                      _ngcontent-ng-c111818244=""
                      className="count hideDesktop"
                    >
                      <span _ngcontent-ng-c111818244="" className="back">
                        {" "}
                        {item?.back12}
                      </span>
                      <span _ngcontent-ng-c111818244="" className="lay">
                        {item?.lay12}{" "}
                      </span>
                    </td>
                  </tr>
                ))}
                {/**/}
                {/**/}
                {/**/}
              </tbody>
            </table>
          </div>
        )}
        {cricketData?.filter(filters[selectedFilter])?.length > 0 && (
          <div
            _ngcontent-ng-c111818244=""
            className="inplay-sportwise ng-star-inserted"
          >
            <div _ngcontent-ng-c111818244="" className="sporthead sporthead2">
              <h3 _ngcontent-ng-c111818244="">Cricket </h3>
            </div>
            <table
              _ngcontent-ng-c111818244=""
              className="table table-hover inplaytbl2"
            >
              <thead _ngcontent-ng-c111818244="" className="hideDesktop">
                <tr>
                  <th
                    _ngcontent-ng-c111818244=""
                    colSpan={2}
                    className="view-mobile"
                  />
                  <th _ngcontent-ng-c111818244="" className="text-center">
                    1
                  </th>
                  <th _ngcontent-ng-c111818244="" className="text-center">
                    X
                  </th>
                  <th _ngcontent-ng-c111818244="" className="text-center">
                    2
                  </th>
                </tr>
              </thead>
              <tbody _ngcontent-ng-c111818244="">
                {cricketData?.filter(filters[selectedFilter])?.map((item) => (
                  <tr _ngcontent-ng-c111818244="" className="ng-star-inserted">
                    <td
                      onClick={() => {
                        navigate(`/game/cricket/${item?.cricketId}`);
                      }}
                      _ngcontent-ng-c111818244=""
                      style={{ cursor: "pointer" }}
                    >
                      <a _ngcontent-ng-c111818244="" className="match-name">
                        <span _ngcontent-ng-c111818244="">
                          {item?.eventName}
                        </span>
                      </a>
                      {selectedFilter != "inPlay" && (
                        <p _ngcontent-ng-c111818244="" className="match-time">
                          {moment(
                            item?.eventDate
                              ? item?.eventDate + "Z"
                              : item?.eventTime + "Z"
                          ).format("DD-MM-yyyy HH:mm")}
                        </p>
                      )}
                      {selectedFilter == "inPlay" && (
                        <span
                          _ngcontent-ng-c111818244=""
                          className="in_play ng-star-inserted"
                        >
                          In-Play
                        </span>
                      )}
                      {/**/}
                      {/**/}
                      {/**/}
                      {/**/}
                    </td>
                    <td _ngcontent-ng-c111818244="" className="text-start"></td>
                    <td
                      _ngcontent-ng-c111818244=""
                      className="count hideDesktop"
                    >
                      <span _ngcontent-ng-c111818244="" className="back">
                        {item?.back1}
                      </span>
                      <span _ngcontent-ng-c111818244="" className="lay">
                        {" "}
                        {item?.lay1}
                      </span>
                    </td>
                    <td
                      _ngcontent-ng-c111818244=""
                      className="count hideDesktop"
                    >
                      <span _ngcontent-ng-c111818244="" className="back">
                        {" "}
                        {item?.back11}
                      </span>
                      <span _ngcontent-ng-c111818244="" className="lay">
                        {item?.lay11}{" "}
                      </span>
                    </td>
                    <td
                      _ngcontent-ng-c111818244=""
                      className="count hideDesktop"
                    >
                      <span _ngcontent-ng-c111818244="" className="back">
                        {" "}
                        {item?.back12}
                      </span>
                      <span _ngcontent-ng-c111818244="" className="lay">
                        {item?.lay12}{" "}
                      </span>
                    </td>
                  </tr>
                ))}
                {/**/}
                {/**/}
                {/**/}
              </tbody>
            </table>
          </div>
        )}
        {tennisData?.filter(filters[selectedFilter])?.length > 0 && (
          <div
            _ngcontent-ng-c111818244=""
            className="inplay-sportwise ng-star-inserted"
          >
            <div _ngcontent-ng-c111818244="" className="sporthead sporthead2">
              <h3 _ngcontent-ng-c111818244="">Tennis </h3>
            </div>
            <table
              _ngcontent-ng-c111818244=""
              className="table table-hover inplaytbl2"
            >
              <thead _ngcontent-ng-c111818244="" className="hideDesktop">
                <tr>
                  <th
                    _ngcontent-ng-c111818244=""
                    colSpan={2}
                    className="view-mobile"
                  />
                  <th _ngcontent-ng-c111818244="" className="text-center">
                    1
                  </th>
                  <th _ngcontent-ng-c111818244="" className="text-center">
                    X
                  </th>
                  <th _ngcontent-ng-c111818244="" className="text-center">
                    2
                  </th>
                </tr>
              </thead>
              <tbody _ngcontent-ng-c111818244="">
                {tennisData?.filter(filters[selectedFilter])?.map((item) => (
                  <tr _ngcontent-ng-c111818244="" className="ng-star-inserted">
                    <td
                      onClick={() => {
                        navigate(`/game/tennis/${item?.tennisId}`);
                      }}
                      _ngcontent-ng-c111818244=""
                      style={{ cursor: "pointer" }}
                    >
                      <a _ngcontent-ng-c111818244="" className="match-name">
                        <span _ngcontent-ng-c111818244="">
                          {item?.eventName}
                        </span>
                      </a>
                      {selectedFilter != "inPlay" && (
                        <p _ngcontent-ng-c111818244="" className="match-time">
                          {moment(
                            item?.eventDate
                              ? item?.eventDate + "Z"
                              : item?.eventTime + "Z"
                          ).format("DD-MM-yyyy HH:mm")}
                        </p>
                      )}
                      {selectedFilter == "inPlay" && (
                        <span
                          _ngcontent-ng-c111818244=""
                          className="in_play ng-star-inserted"
                        >
                          In-Play
                        </span>
                      )}
                      {/**/}
                      {/**/}
                      {/**/}
                      {/**/}
                    </td>
                    <td _ngcontent-ng-c111818244="" className="text-start"></td>
                    <td
                      _ngcontent-ng-c111818244=""
                      className="count hideDesktop"
                    >
                      <span _ngcontent-ng-c111818244="" className="back">
                        {item?.back1}
                      </span>
                      <span _ngcontent-ng-c111818244="" className="lay">
                        {" "}
                        {item?.lay1}
                      </span>
                    </td>
                    <td
                      _ngcontent-ng-c111818244=""
                      className="count hideDesktop"
                    >
                      <span _ngcontent-ng-c111818244="" className="back">
                        {" "}
                        {item?.back11}
                      </span>
                      <span _ngcontent-ng-c111818244="" className="lay">
                        {item?.lay11}{" "}
                      </span>
                    </td>
                    <td
                      _ngcontent-ng-c111818244=""
                      className="count hideDesktop"
                    >
                      <span _ngcontent-ng-c111818244="" className="back">
                        {" "}
                        {item?.back12}
                      </span>
                      <span _ngcontent-ng-c111818244="" className="lay">
                        {item?.lay12}{" "}
                      </span>
                    </td>
                  </tr>
                ))}
                {/**/}
                {/**/}
                {/**/}
              </tbody>
            </table>
          </div>
        )}
        <div
          _ngcontent-ng-c111818244=""
          className="inplay-sportwise ng-star-inserted"
        >
          <div _ngcontent-ng-c111818244="" className="sporthead sporthead2">
            <h3 _ngcontent-ng-c111818244="">Horse Racing </h3>
          </div>
          <table
            _ngcontent-ng-c111818244=""
            className="table table-hover inplaytbl2"
          >
            <thead _ngcontent-ng-c111818244="" className="hideDesktop">
              <tr>
                <th
                  _ngcontent-ng-c111818244=""
                  colSpan={2}
                  className="view-mobile"
                />
                <th _ngcontent-ng-c111818244="" className="text-center">
                  1
                </th>
                <th _ngcontent-ng-c111818244="" className="text-center">
                  X
                </th>
                <th _ngcontent-ng-c111818244="" className="text-center">
                  2
                </th>
              </tr>
            </thead>
            <tbody _ngcontent-ng-c111818244="">
              <tr _ngcontent-ng-c111818244="" className="ng-star-inserted">
                <td _ngcontent-ng-c111818244="" style={{ cursor: "pointer" }}>
                  <a _ngcontent-ng-c111818244="" className="match-name">
                    <span _ngcontent-ng-c111818244="">Kalgoorlie</span>
                  </a>
                  <span
                    _ngcontent-ng-c111818244=""
                    className="in_play ng-star-inserted"
                  >
                    In-Play
                  </span>
                  {/**/}
                  {/**/}
                  {/**/}
                  {/**/}
                </td>
                <td _ngcontent-ng-c111818244="" className="text-start">
                  {/**/}
                  {/**/}
                  {/**/}
                  {/**/}
                  {/**/}
                </td>
                <td _ngcontent-ng-c111818244="" className="count hideDesktop">
                  <span _ngcontent-ng-c111818244="" className="back">
                    0
                  </span>
                  <span _ngcontent-ng-c111818244="" className="lay">
                    {" "}
                    0
                  </span>
                </td>
                <td _ngcontent-ng-c111818244="" className="count hideDesktop">
                  <span _ngcontent-ng-c111818244="" className="back">
                    {" "}
                    0
                  </span>
                  <span _ngcontent-ng-c111818244="" className="lay">
                    0
                  </span>
                </td>
                <td _ngcontent-ng-c111818244="" className="count hideDesktop">
                  <span _ngcontent-ng-c111818244="" className="back">
                    {" "}
                    0
                  </span>
                  <span _ngcontent-ng-c111818244="" className="lay">
                    0{" "}
                  </span>
                </td>
              </tr>
              {/**/}
              {/**/}
              <tr _ngcontent-ng-c111818244="" className="ng-star-inserted">
                <td _ngcontent-ng-c111818244="" style={{ cursor: "pointer" }}>
                  <a _ngcontent-ng-c111818244="" className="match-name">
                    <span _ngcontent-ng-c111818244="">Toodyay</span>
                  </a>
                  <span
                    _ngcontent-ng-c111818244=""
                    className="in_play ng-star-inserted"
                  >
                    In-Play
                  </span>
                  {/**/}
                  {/**/}
                  {/**/}
                  {/**/}
                </td>
                <td _ngcontent-ng-c111818244="" className="text-start">
                  {/**/}
                  {/**/}
                  {/**/}
                  {/**/}
                  {/**/}
                </td>
                <td _ngcontent-ng-c111818244="" className="count hideDesktop">
                  <span _ngcontent-ng-c111818244="" className="back">
                    3.3
                  </span>
                  <span _ngcontent-ng-c111818244="" className="lay">
                    {" "}
                    900
                  </span>
                </td>
                <td _ngcontent-ng-c111818244="" className="count hideDesktop">
                  <span _ngcontent-ng-c111818244="" className="back">
                    {" "}
                    3
                  </span>
                  <span _ngcontent-ng-c111818244="" className="lay">
                    900
                  </span>
                </td>
                <td _ngcontent-ng-c111818244="" className="count hideDesktop">
                  <span _ngcontent-ng-c111818244="" className="back">
                    {" "}
                    2.78
                  </span>
                  <span _ngcontent-ng-c111818244="" className="lay">
                    900{" "}
                  </span>
                </td>
              </tr>
              {/**/}
              {/**/}
              <tr _ngcontent-ng-c111818244="" className="ng-star-inserted">
                <td _ngcontent-ng-c111818244="" style={{ cursor: "pointer" }}>
                  <a _ngcontent-ng-c111818244="" className="match-name">
                    <span _ngcontent-ng-c111818244="">HYDERABAD R1</span>
                  </a>
                  <span
                    _ngcontent-ng-c111818244=""
                    className="in_play ng-star-inserted"
                  >
                    In-Play
                  </span>
                  {/**/}
                  {/**/}
                  {/**/}
                  {/**/}
                </td>
                <td _ngcontent-ng-c111818244="" className="text-start">
                  {/**/}
                  {/**/}
                  {/**/}
                  {/**/}
                  {/**/}
                </td>
                <td _ngcontent-ng-c111818244="" className="count hideDesktop">
                  <span _ngcontent-ng-c111818244="" className="back">
                    4.5
                  </span>
                  <span _ngcontent-ng-c111818244="" className="lay">
                    {" "}
                    0
                  </span>
                </td>
                <td _ngcontent-ng-c111818244="" className="count hideDesktop">
                  <span _ngcontent-ng-c111818244="" className="back">
                    {" "}
                    16
                  </span>
                  <span _ngcontent-ng-c111818244="" className="lay">
                    0
                  </span>
                </td>
                <td _ngcontent-ng-c111818244="" className="count hideDesktop">
                  <span _ngcontent-ng-c111818244="" className="back">
                    {" "}
                    21
                  </span>
                  <span _ngcontent-ng-c111818244="" className="lay">
                    0{" "}
                  </span>
                </td>
              </tr>
              {/**/}
              {/**/}
              <tr _ngcontent-ng-c111818244="" className="ng-star-inserted">
                <td _ngcontent-ng-c111818244="" style={{ cursor: "pointer" }}>
                  <a _ngcontent-ng-c111818244="" className="match-name">
                    <span _ngcontent-ng-c111818244="">PUNE R1</span>
                  </a>
                  <span
                    _ngcontent-ng-c111818244=""
                    className="in_play ng-star-inserted"
                  >
                    In-Play
                  </span>
                  {/**/}
                  {/**/}
                  {/**/}
                  {/**/}
                </td>
                <td _ngcontent-ng-c111818244="" className="text-start">
                  {/**/}
                  {/**/}
                  {/**/}
                  {/**/}
                  {/**/}
                </td>
                <td _ngcontent-ng-c111818244="" className="count hideDesktop">
                  <span _ngcontent-ng-c111818244="" className="back">
                    0
                  </span>
                  <span _ngcontent-ng-c111818244="" className="lay">
                    {" "}
                    0
                  </span>
                </td>
                <td _ngcontent-ng-c111818244="" className="count hideDesktop">
                  <span _ngcontent-ng-c111818244="" className="back">
                    {" "}
                    0
                  </span>
                  <span _ngcontent-ng-c111818244="" className="lay">
                    0
                  </span>
                </td>
                <td _ngcontent-ng-c111818244="" className="count hideDesktop">
                  <span _ngcontent-ng-c111818244="" className="back">
                    {" "}
                    0
                  </span>
                  <span _ngcontent-ng-c111818244="" className="lay">
                    0{" "}
                  </span>
                </td>
              </tr>
              {/**/}
              {/**/}
              <tr _ngcontent-ng-c111818244="" className="ng-star-inserted">
                <td _ngcontent-ng-c111818244="" style={{ cursor: "pointer" }}>
                  <a _ngcontent-ng-c111818244="" className="match-name">
                    <span _ngcontent-ng-c111818244="">HYDERABAD R2</span>
                  </a>
                  <span
                    _ngcontent-ng-c111818244=""
                    className="in_play ng-star-inserted"
                  >
                    In-Play
                  </span>
                  {/**/}
                  {/**/}
                  {/**/}
                  {/**/}
                </td>
                <td _ngcontent-ng-c111818244="" className="text-start">
                  {/**/}
                  {/**/}
                  {/**/}
                  {/**/}
                  {/**/}
                </td>
                <td _ngcontent-ng-c111818244="" className="count hideDesktop">
                  <span _ngcontent-ng-c111818244="" className="back">
                    0
                  </span>
                  <span _ngcontent-ng-c111818244="" className="lay">
                    {" "}
                    0
                  </span>
                </td>
                <td _ngcontent-ng-c111818244="" className="count hideDesktop">
                  <span _ngcontent-ng-c111818244="" className="back">
                    {" "}
                    0
                  </span>
                  <span _ngcontent-ng-c111818244="" className="lay">
                    0
                  </span>
                </td>
                <td _ngcontent-ng-c111818244="" className="count hideDesktop">
                  <span _ngcontent-ng-c111818244="" className="back">
                    {" "}
                    0
                  </span>
                  <span _ngcontent-ng-c111818244="" className="lay">
                    0{" "}
                  </span>
                </td>
              </tr>
              {/**/}
              {/**/}
              <tr _ngcontent-ng-c111818244="" className="ng-star-inserted">
                <td _ngcontent-ng-c111818244="" style={{ cursor: "pointer" }}>
                  <a _ngcontent-ng-c111818244="" className="match-name">
                    <span _ngcontent-ng-c111818244="">PUNE R2</span>
                  </a>
                  <span
                    _ngcontent-ng-c111818244=""
                    className="in_play ng-star-inserted"
                  >
                    In-Play
                  </span>
                  {/**/}
                  {/**/}
                  {/**/}
                  {/**/}
                </td>
                <td _ngcontent-ng-c111818244="" className="text-start">
                  {/**/}
                  {/**/}
                  {/**/}
                  {/**/}
                  {/**/}
                </td>
                <td _ngcontent-ng-c111818244="" className="count hideDesktop">
                  <span _ngcontent-ng-c111818244="" className="back">
                    6
                  </span>
                  <span _ngcontent-ng-c111818244="" className="lay">
                    {" "}
                    7
                  </span>
                </td>
                <td _ngcontent-ng-c111818244="" className="count hideDesktop">
                  <span _ngcontent-ng-c111818244="" className="back">
                    {" "}
                    7
                  </span>
                  <span _ngcontent-ng-c111818244="" className="lay">
                    0
                  </span>
                </td>
                <td _ngcontent-ng-c111818244="" className="count hideDesktop">
                  <span _ngcontent-ng-c111818244="" className="back">
                    {" "}
                    4
                  </span>
                  <span _ngcontent-ng-c111818244="" className="lay">
                    5{" "}
                  </span>
                </td>
              </tr>
              {/**/}
              {/**/}
              <tr _ngcontent-ng-c111818244="" className="ng-star-inserted">
                <td _ngcontent-ng-c111818244="" style={{ cursor: "pointer" }}>
                  <a _ngcontent-ng-c111818244="" className="match-name">
                    <span _ngcontent-ng-c111818244="">HYDERABAD R3</span>
                  </a>
                  <span
                    _ngcontent-ng-c111818244=""
                    className="in_play ng-star-inserted"
                  >
                    In-Play
                  </span>
                  {/**/}
                  {/**/}
                  {/**/}
                  {/**/}
                </td>
                <td _ngcontent-ng-c111818244="" className="text-start">
                  {/**/}
                  {/**/}
                  {/**/}
                  {/**/}
                  {/**/}
                </td>
                <td _ngcontent-ng-c111818244="" className="count hideDesktop">
                  <span _ngcontent-ng-c111818244="" className="back">
                    0
                  </span>
                  <span _ngcontent-ng-c111818244="" className="lay">
                    {" "}
                    0
                  </span>
                </td>
                <td _ngcontent-ng-c111818244="" className="count hideDesktop">
                  <span _ngcontent-ng-c111818244="" className="back">
                    {" "}
                    0
                  </span>
                  <span _ngcontent-ng-c111818244="" className="lay">
                    0
                  </span>
                </td>
                <td _ngcontent-ng-c111818244="" className="count hideDesktop">
                  <span _ngcontent-ng-c111818244="" className="back">
                    {" "}
                    0
                  </span>
                  <span _ngcontent-ng-c111818244="" className="lay">
                    0{" "}
                  </span>
                </td>
              </tr>
              {/**/}
              {/**/}
              <tr _ngcontent-ng-c111818244="" className="ng-star-inserted">
                <td _ngcontent-ng-c111818244="" style={{ cursor: "pointer" }}>
                  <a _ngcontent-ng-c111818244="" className="match-name">
                    <span _ngcontent-ng-c111818244="">PUNE R3</span>
                  </a>
                  <span
                    _ngcontent-ng-c111818244=""
                    className="in_play ng-star-inserted"
                  >
                    In-Play
                  </span>
                  {/**/}
                  {/**/}
                  {/**/}
                  {/**/}
                </td>
                <td _ngcontent-ng-c111818244="" className="text-start">
                  {/**/}
                  {/**/}
                  {/**/}
                  {/**/}
                  {/**/}
                </td>
                <td _ngcontent-ng-c111818244="" className="count hideDesktop">
                  <span _ngcontent-ng-c111818244="" className="back">
                    7
                  </span>
                  <span _ngcontent-ng-c111818244="" className="lay">
                    {" "}
                    0
                  </span>
                </td>
                <td _ngcontent-ng-c111818244="" className="count hideDesktop">
                  <span _ngcontent-ng-c111818244="" className="back">
                    {" "}
                    7
                  </span>
                  <span _ngcontent-ng-c111818244="" className="lay">
                    0
                  </span>
                </td>
                <td _ngcontent-ng-c111818244="" className="count hideDesktop">
                  <span _ngcontent-ng-c111818244="" className="back">
                    {" "}
                    5
                  </span>
                  <span _ngcontent-ng-c111818244="" className="lay">
                    0{" "}
                  </span>
                </td>
              </tr>
              {/**/}
              {/**/}
              <tr _ngcontent-ng-c111818244="" className="ng-star-inserted">
                <td _ngcontent-ng-c111818244="" style={{ cursor: "pointer" }}>
                  <a _ngcontent-ng-c111818244="" className="match-name">
                    <span _ngcontent-ng-c111818244="">HYDERABAD R4</span>
                  </a>
                  <span
                    _ngcontent-ng-c111818244=""
                    className="in_play ng-star-inserted"
                  >
                    In-Play
                  </span>
                  {/**/}
                  {/**/}
                  {/**/}
                  {/**/}
                </td>
                <td _ngcontent-ng-c111818244="" className="text-start">
                  {/**/}
                  {/**/}
                  {/**/}
                  {/**/}
                  {/**/}
                </td>
                <td _ngcontent-ng-c111818244="" className="count hideDesktop">
                  <span _ngcontent-ng-c111818244="" className="back">
                    0
                  </span>
                  <span _ngcontent-ng-c111818244="" className="lay">
                    {" "}
                    0
                  </span>
                </td>
                <td _ngcontent-ng-c111818244="" className="count hideDesktop">
                  <span _ngcontent-ng-c111818244="" className="back">
                    {" "}
                    0
                  </span>
                  <span _ngcontent-ng-c111818244="" className="lay">
                    0
                  </span>
                </td>
                <td _ngcontent-ng-c111818244="" className="count hideDesktop">
                  <span _ngcontent-ng-c111818244="" className="back">
                    {" "}
                    0
                  </span>
                  <span _ngcontent-ng-c111818244="" className="lay">
                    0{" "}
                  </span>
                </td>
              </tr>
              {/**/}
              {/**/}
              <tr _ngcontent-ng-c111818244="" className="ng-star-inserted">
                <td _ngcontent-ng-c111818244="" style={{ cursor: "pointer" }}>
                  <a _ngcontent-ng-c111818244="" className="match-name">
                    <span _ngcontent-ng-c111818244="">PUNE R4</span>
                  </a>
                  <span
                    _ngcontent-ng-c111818244=""
                    className="in_play ng-star-inserted"
                  >
                    In-Play
                  </span>
                  {/**/}
                  {/**/}
                  {/**/}
                  {/**/}
                </td>
                <td _ngcontent-ng-c111818244="" className="text-start">
                  {/**/}
                  {/**/}
                  {/**/}
                  {/**/}
                  {/**/}
                </td>
                <td _ngcontent-ng-c111818244="" className="count hideDesktop">
                  <span _ngcontent-ng-c111818244="" className="back">
                    11
                  </span>
                  <span _ngcontent-ng-c111818244="" className="lay">
                    {" "}
                    0
                  </span>
                </td>
                <td _ngcontent-ng-c111818244="" className="count hideDesktop">
                  <span _ngcontent-ng-c111818244="" className="back">
                    {" "}
                    8
                  </span>
                  <span _ngcontent-ng-c111818244="" className="lay">
                    0
                  </span>
                </td>
                <td _ngcontent-ng-c111818244="" className="count hideDesktop">
                  <span _ngcontent-ng-c111818244="" className="back">
                    {" "}
                    11
                  </span>
                  <span _ngcontent-ng-c111818244="" className="lay">
                    0{" "}
                  </span>
                </td>
              </tr>
              {/**/}
              {/**/}
              <tr _ngcontent-ng-c111818244="" className="ng-star-inserted">
                <td _ngcontent-ng-c111818244="" style={{ cursor: "pointer" }}>
                  <a _ngcontent-ng-c111818244="" className="match-name">
                    <span _ngcontent-ng-c111818244="">HYDERABAD R5</span>
                  </a>
                  <span
                    _ngcontent-ng-c111818244=""
                    className="in_play ng-star-inserted"
                  >
                    In-Play
                  </span>
                  {/**/}
                  {/**/}
                  {/**/}
                  {/**/}
                </td>
                <td _ngcontent-ng-c111818244="" className="text-start">
                  {/**/}
                  {/**/}
                  {/**/}
                  {/**/}
                  {/**/}
                </td>
                <td _ngcontent-ng-c111818244="" className="count hideDesktop">
                  <span _ngcontent-ng-c111818244="" className="back">
                    0
                  </span>
                  <span _ngcontent-ng-c111818244="" className="lay">
                    {" "}
                    0
                  </span>
                </td>
                <td _ngcontent-ng-c111818244="" className="count hideDesktop">
                  <span _ngcontent-ng-c111818244="" className="back">
                    {" "}
                    0
                  </span>
                  <span _ngcontent-ng-c111818244="" className="lay">
                    0
                  </span>
                </td>
                <td _ngcontent-ng-c111818244="" className="count hideDesktop">
                  <span _ngcontent-ng-c111818244="" className="back">
                    {" "}
                    0
                  </span>
                  <span _ngcontent-ng-c111818244="" className="lay">
                    0{" "}
                  </span>
                </td>
              </tr>
              {/**/}
              {/**/}
              <tr _ngcontent-ng-c111818244="" className="ng-star-inserted">
                <td _ngcontent-ng-c111818244="" style={{ cursor: "pointer" }}>
                  <a _ngcontent-ng-c111818244="" className="match-name">
                    <span _ngcontent-ng-c111818244="">PUNE R5</span>
                  </a>
                  <span
                    _ngcontent-ng-c111818244=""
                    className="in_play ng-star-inserted"
                  >
                    In-Play
                  </span>
                  {/**/}
                  {/**/}
                  {/**/}
                  {/**/}
                </td>
                <td _ngcontent-ng-c111818244="" className="text-start">
                  {/**/}
                  {/**/}
                  {/**/}
                  {/**/}
                  {/**/}
                </td>
                <td _ngcontent-ng-c111818244="" className="count hideDesktop">
                  <span _ngcontent-ng-c111818244="" className="back">
                    11
                  </span>
                  <span _ngcontent-ng-c111818244="" className="lay">
                    {" "}
                    0
                  </span>
                </td>
                <td _ngcontent-ng-c111818244="" className="count hideDesktop">
                  <span _ngcontent-ng-c111818244="" className="back">
                    {" "}
                    11
                  </span>
                  <span _ngcontent-ng-c111818244="" className="lay">
                    0
                  </span>
                </td>
                <td _ngcontent-ng-c111818244="" className="count hideDesktop">
                  <span _ngcontent-ng-c111818244="" className="back">
                    {" "}
                    11
                  </span>
                  <span _ngcontent-ng-c111818244="" className="lay">
                    0{" "}
                  </span>
                </td>
              </tr>
              {/**/}
              {/**/}
              <tr _ngcontent-ng-c111818244="" className="ng-star-inserted">
                <td _ngcontent-ng-c111818244="" style={{ cursor: "pointer" }}>
                  <a _ngcontent-ng-c111818244="" className="match-name">
                    <span _ngcontent-ng-c111818244="">PUNE R6</span>
                  </a>
                  <span
                    _ngcontent-ng-c111818244=""
                    className="in_play ng-star-inserted"
                  >
                    In-Play
                  </span>
                  {/**/}
                  {/**/}
                  {/**/}
                  {/**/}
                </td>
                <td _ngcontent-ng-c111818244="" className="text-start">
                  {/**/}
                  {/**/}
                  {/**/}
                  {/**/}
                  {/**/}
                </td>
                <td _ngcontent-ng-c111818244="" className="count hideDesktop">
                  <span _ngcontent-ng-c111818244="" className="back">
                    11
                  </span>
                  <span _ngcontent-ng-c111818244="" className="lay">
                    {" "}
                    0
                  </span>
                </td>
                <td _ngcontent-ng-c111818244="" className="count hideDesktop">
                  <span _ngcontent-ng-c111818244="" className="back">
                    {" "}
                    11
                  </span>
                  <span _ngcontent-ng-c111818244="" className="lay">
                    0
                  </span>
                </td>
                <td _ngcontent-ng-c111818244="" className="count hideDesktop">
                  <span _ngcontent-ng-c111818244="" className="back">
                    {" "}
                    11
                  </span>
                  <span _ngcontent-ng-c111818244="" className="lay">
                    0{" "}
                  </span>
                </td>
              </tr>
              {/**/}
              {/**/}
              <tr _ngcontent-ng-c111818244="" className="ng-star-inserted">
                <td _ngcontent-ng-c111818244="" style={{ cursor: "pointer" }}>
                  <a _ngcontent-ng-c111818244="" className="match-name">
                    <span _ngcontent-ng-c111818244="">PUNE R7</span>
                  </a>
                  <span
                    _ngcontent-ng-c111818244=""
                    className="in_play ng-star-inserted"
                  >
                    In-Play
                  </span>
                  {/**/}
                  {/**/}
                  {/**/}
                  {/**/}
                </td>
                <td _ngcontent-ng-c111818244="" className="text-start">
                  {/**/}
                  {/**/}
                  {/**/}
                  {/**/}
                  {/**/}
                </td>
                <td _ngcontent-ng-c111818244="" className="count hideDesktop">
                  <span _ngcontent-ng-c111818244="" className="back">
                    3.25
                  </span>
                  <span _ngcontent-ng-c111818244="" className="lay">
                    {" "}
                    4
                  </span>
                </td>
                <td _ngcontent-ng-c111818244="" className="count hideDesktop">
                  <span _ngcontent-ng-c111818244="" className="back">
                    {" "}
                    11
                  </span>
                  <span _ngcontent-ng-c111818244="" className="lay">
                    0
                  </span>
                </td>
                <td _ngcontent-ng-c111818244="" className="count hideDesktop">
                  <span _ngcontent-ng-c111818244="" className="back">
                    {" "}
                    2.5
                  </span>
                  <span _ngcontent-ng-c111818244="" className="lay">
                    2.7{" "}
                  </span>
                </td>
              </tr>
              {/**/}
              {/**/}
              {/**/}
            </tbody>
          </table>
        </div>
        {/**/}
        {/**/}
        {/**/}
        {/**/}
        <div _ngcontent-ng-c111818244="" className="casino-inplay-data">
          <app-live-casino _ngcontent-ng-c679600774="" _nghost-ng-c898714788="">
            <div
              _ngcontent-ng-c898714788=""
              className="position-relative mobile-men"
            >
              <ul
                _ngcontent-ng-c898714788=""
                id="menuListId"
                className="menu-list"
              >
                {casinoList?.map((casino) => (
                  <li
                    _ngcontent-ng-c898714788=""
                    className={`menu-item ${
                      casino.active ? "active" : ""
                    } ng-star-inserted`}
                    id="sportsBar0"
                    onClick={() => {
                      setCasinoList((prev) =>
                        prev.map((item) => {
                          item.active = item.name === casino.name;
                          return item;
                        })
                      );
                    }}
                  >
                    <div _ngcontent-ng-c898714788="">
                      <span
                        _ngcontent-ng-c898714788=""
                        className="menutext orange-nav-ic-txt"
                      >
                        {casino.name}
                      </span>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
            {casinoList?.find((item) => item.active) &&
              casinoList?.find((item) => item.active)?.enum && (
                <div
                  _ngcontent-ng-c898714788=""
                  className="position-relative ng-star-inserted"
                >
                  <div
                    _ngcontent-ng-c898714788=""
                    id="home"
                    className="tab-pane sports active"
                  >
                    <ul
                      _ngcontent-ng-c898714788=""
                      id="menuSubListId"
                      className="nav nav-tabs-casino game-nav-bar menu-list-casino"
                    >
                      {casinoList
                        ?.find((item) => item.active)
                        ?.enum.map((casino) => (
                          <li
                            _ngcontent-ng-c898714788=""
                            className="nav-item casinoname-item mainTabs text-center aaa ng-star-inserted"
                            id="sportsBarSub0"
                            onClick={() => {
                              setCasinoList((prev) =>
                                prev.map((item) => {
                                  item?.enum?.map((sub) => {
                                    sub.active = sub.name === casino.name;
                                    return sub;
                                  });
                                  return item;
                                })
                              );
                            }}
                          >
                            <a
                              _ngcontent-ng-c898714788=""
                              className={`nav-link 
                                  ${casino?.active ? "active" : ""}
                                }`}
                            >
                              <div _ngcontent-ng-c898714788="">
                                {casino.name}
                              </div>
                            </a>
                          </li>
                        ))}
                    </ul>
                  </div>
                  <div _ngcontent-ng-c898714788="">
                    <div _ngcontent-ng-c898714788="" className="searchBox">
                      <a _ngcontent-ng-c898714788="">
                        <i
                          _ngcontent-ng-c898714788=""
                          className="fas fa-search ng-star-inserted"
                        />
                        {/**/}
                        {/**/}
                      </a>
                    </div>
                    <div
                      _ngcontent-ng-c898714788=""
                      className="searchInput hideSearchBar"
                    >
                      <input
                        _ngcontent-ng-c898714788=""
                        id="CasinolobbySearch"
                        name="search"
                        placeholder="Search..."
                        type="text"
                        className="form-control ng-untouched ng-pristine ng-valid"
                      />
                    </div>
                  </div>
                </div>
              )}

            <div _ngcontent-ng-c898714788="" className="main-con">
              <div _ngcontent-ng-c898714788="" className="row home">
                {casinoList?.find((item) => item?.active)?.enum
                  ? getCasinoGames(casinoListMap[
                      casinoList
                        ?.find((item) => item?.active)
                        ?.enum?.find((a) => a.active)?.value
                    ])?.map((casino) => (
                      <div
                        _ngcontent-ng-c898714788=""
                        className="col col-4 col-md-3 col-sm-3 col-xl-3 pointer ng-star-inserted"
                      >
                        <div
                          _ngcontent-ng-c898714788=""
                          className="casinoicons"
                        >
                          <a
                            _ngcontent-ng-c898714788=""
                            onClick={() => {
                              if (casino.link) {
                                setShowCasinoLoader(true);
                                setTimeout(() => navigate(casino.link), 1500);
                              }
                            }}
                          >
                            <img
                              _ngcontent-ng-c898714788=""
                              className="img-fluid"
                              src={casino.image}
                              alt={casino.name}
                            />
                            {/* <div
                              _ngcontent-ng-c898714788=""
                              className="casino-bottom"
                            >
                              {" "}
                              {casino.name}{" "}
                            </div> */}
                          </a>
                        </div>
                      </div>
                    ))
                  : getCasinoGames(casinoListMap[
                      casinoList?.find((item) => item.active)?.name
                    ])?.map((casino) => (
                      <div
                        _ngcontent-ng-c898714788=""
                        className="col col-4 col-md-3 col-sm-3 col-xl-3 pointer ng-star-inserted"
                      >
                        <div
                          _ngcontent-ng-c898714788=""
                          className="casinoicons"
                        >
                          <a
                            _ngcontent-ng-c898714788=""
                            onClick={() => {
                              if (casino.link) {
                                setShowCasinoLoader(true);
                                setTimeout(() => navigate(casino.link), 1500);
                              }
                            }}
                          >
                            <img
                              _ngcontent-ng-c898714788=""
                              className="img-fluid"
                              src={casino.image}
                              alt={casino.name}
                            />
                            {/* <div
                              _ngcontent-ng-c898714788=""
                              className="casino-bottom"
                            >
                              {" "}
                              {casino.name}{" "}
                            </div> */}
                          </a>
                        </div>
                      </div>
                    ))}
              </div>
            </div>
          </app-live-casino>
        </div>
      </div>
    </app-inplay>
  );
}
